import { Component, Input, Output, ViewChild, EventEmitter, signal, computed } from '@angular/core';
import { MemberRosterComponent } from '../../member-roster/member-roster.component';
import { Member } from 'src/app/services/models/member';

@Component({
  selector: 'app-member-roster-dialog',
  templateUrl: './member-roster-dialog.component.html',
  styleUrl: './member-roster-dialog.component.scss'
})
export class MemberRosterDialogComponent {

  @Input() member: Member;
  @Output() onCancel = new EventEmitter();
  @ViewChild('memberrostercomponent') memberrostercomponent: MemberRosterComponent

  display: boolean = true;
  dialogCaption: string = "Add To My Roster";
  successMessage = signal("");
  failureMessage = signal("");
  showSuccess = computed(() => this.successMessage()?.length > 0);
  showError = computed(() => this.failureMessage()?.length > 0);

  public cancelDialog() : void {
    this.onCancel.emit();
  }

  public updateDialog() : void {
    this.memberrostercomponent?.saveRoster();
  }

  public onSaveSuccess($event : string) : void {
    this.failureMessage.set("");
    this.successMessage.set($event);
  }

  public onSaveFailed($event : string) : void {
    this.successMessage.set("");
    this.failureMessage.set($event);
  }

  public onRosterChange() : void {
    this.successMessage.set("");
    this.failureMessage.set("");
  }

  public get isSaveDisabled() : boolean{
    return !this.memberrostercomponent?.displayproviders?.find(provider => provider.selected && !provider.disabled);
  }
}
